// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3JAYd","upload":"Small_upload__1KWIS","imageWrap":"Small_imageWrap__JH1mK","removeBtn":"Small_removeBtn__2Vgip"};